import React from 'react'
import './styles.scss'
import TrackMap from '../../components/TrackMap'

// const hoehenmeterProfil = {
//   Route1: require('../runningRoute/img/hoehenmeterprofil_1.svg'),
// }

// const icons = {
//   Time: require('../runningRoute/img/sued.svg'),
//   Speed: require('../runningRoute/img/sued.svg'),
//   Up: require('../runningRoute/img/sued.svg'),
//   Down: require('../runningRoute/img/sued.svg'),
// }

// const icons = {
//   'Krankheit (2500)': require('../runningRoute/img/krankheit.svg')
// }

export const iconLeicht = new L.Icon({
  iconUrl: require('../main/imgs/pinLeicht.svg'),
  iconRetinaUrl: require('../main/imgs/pinLeicht.svg'),
  iconAnchor: [25, 59],
  popupAnchor: [0, -40],
  iconSize: [50, 80],
  // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  shadowSize: [68, 95],
  shadowAnchor: [20, 92],
  className: 'icon'
})

export const iconLeichtSpiegelverkehrt = new L.Icon({
  iconUrl: require('../main/imgs/pinLeichtSpiegelverkehrt.svg'),
  iconRetinaUrl: require('../main/imgs/pinLeichtSpiegelverkehrt.svg'),
  iconAnchor: [25, 59],
  popupAnchor: [0, -40],
  iconSize: [50, 80],
  // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  shadowSize: [68, 95],
  shadowAnchor: [20, 92],
  className: 'icon'
})

export const iconMittel = new L.Icon({
  iconUrl: require('../main/imgs/pinMittel.svg'),
  iconRetinaUrl: require('../main/imgs/pinMittel.svg'),
  iconAnchor: [25, 59],
  popupAnchor: [0, -40],
  iconSize: [50, 80],
  // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  shadowSize: [68, 95],
  shadowAnchor: [20, 92],
  className: 'icon'
})

export const iconSchwer = new L.Icon({
  iconUrl: require('../main/imgs/pinSchwer.svg'),
  iconRetinaUrl: require('../main/imgs/pinSchwer.svg'),
  iconAnchor: [25, 59],
  popupAnchor: [0, -40],
  iconSize: [50, 80],
  // shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  shadowSize: [68, 95],
  shadowAnchor: [20, 92],
  className: 'icon'
})

export default class runningRoute extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isExpanded: false
    }
    this.toggleMore = this.toggleMore.bind(this)
  }

  toggleMore(e) {
    e.preventDefault()
    if (this.state.isExpanded) {
      this.setState(
        {
          isExpanded: false
        },
        () => console.log('collapse!')
      )
    } else {
      this.setState(
        {
          isExpanded: true
        },
        () => console.log('expand...')
      )
    }
  }

  render() {
    return (
      <>
      <div className='ui container'>
        <div className='titleWrapper'>
          <div className='routeTitle'>
            <h3>{this.props.routeTitle}</h3>
          </div>
          <div className='routeSubtitle'>
            <h4>{this.props.routeSubtitle}</h4>
          </div>
        </div>
      </div>

      <div className='ui container'>

        <div className='routeDetail'>
          <div className='levelWrapper'>
            <span className={this.props.level}>{this.props.level}</span>
          </div>
          <div className='iconWrapper'>
            <span><i className='icon clock outline' />{this.props.time}</span>
            <span><i className='icon arrows alternate horizontal' />{this.props.distance}</span>
            <span><i className='icon long arrow alternate up' />{this.props.elevationGain}</span>
            <span>{this.props.start}</span>
          </div>
        </div>

      </div>

      <div className='ui container trackMap'>
        <TrackMap
          lng={this.props.lng}
          lat={this.props.lat}

          firstCorner={[this.props.latFirstCorner, this.props.lngFirstCorner]}
          lastCorner={[this.props.latLastCorner, this.props.lngLastCorner]}

          mobileZoom={this.props.mobileZoom}
          desktopZoom={this.props.desktopZoom}
          track={this.props.track}
          markerPositionLat={this.props.markerPositionLat}
          markerPositionLng={this.props.markerPositionLng}
          getStyle={this.props.getStyle}
          iconStart={this.props.iconStart}
        />
      </div>

      {/*
      <div className='ui container'>
        <img
          src={hoehenmeterProfil[this.props.trackNummer]}
          alt=''
          className='ui fluid image'
        />
      </div>
      */}

      <div className='ui text container' style={{ marginBottom: '5em' }}>
        <p>
          {this.props.text}
        </p>
      </div>

      </>
    )
  }
}
